import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsAppGroupIdUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaigns_data_v2",
  "/engagement/campaigns_data",
  "/engagement/:app_group_id/feature_flags/:rollout_id/experiment_usage",
  "/engagement/feature_flag_rollouts_data",
  "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies",
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id",
  "/engagement/:app_group_id/surveys",
];
